import { makeStyles } from 'tss-react/mui';

const useStylesFilteredText: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  filteredText: {
    '& a': {
      textDecoration: 'none',
      color: theme.palette.secondary.main,
      fontWeight: 500,
    },
    '& > p': {
      marginTop: 0,
      marginBottom: 0,
    },
  },
}));

export default useStylesFilteredText;
